appSocial.component('compareCouple', {
    templateUrl: 'widgets/leader-compare/components/compare-couple/CompareCoupleComponent.html',
    controller: class CompareCoupleComponent {
        constructor($scope,
                    SocialLocaleService,
                    SocialUtils,
                    LeadersCompareService,
                    SocialActionService,
                    SocialTypes) {

            this.translation = SocialLocaleService.translation;

            /**
             * @type {LeadersCompareService}
             */
            this.compareService = LeadersCompareService;

            /**
             * @type {SocialUtils}
             */
            this.utils = SocialUtils;

            /**
             * @type {SocialActionService}
             */
            this.actionService = SocialActionService;

            /**
             * @type {SocialTypes}
             */
            this.types = SocialTypes;

            /**
             * @type {Trader}
             */
            this.leaderLeft = this.compareService.traders[0];

            /**
             * @type {Trader}
             */
            this.leaderRight = this.compareService.traders[1];

            $scope.$on('leadersCompare.add', (event, data) => {
                if (!this.leaderLeft) {
                    this.leaderLeft = data.trader;
                } else {
                    this.leaderRight = data.trader;
                }
            });
            $scope.$on('leadersCompare.remove', (event, data) => {
                if (this.leaderLeft && (this.leaderLeft.id === data.trader.id)) {
                    this.leaderLeft = null;
                }

                if (this.leaderRight && (this.leaderRight.id === data.trader.id)) {
                    this.leaderRight = null;
                }
            });
        }

        $onInit() {
            this.moreParameters = false;
        }

        $onChanges(changes) {
        }

        $onDestroy() {
        }

        toggleMoreParameters() {
            this.moreParameters = !this.moreParameters;
        }

        stopComparing() {
            this.compareService.disableSelection();
        }

        clearLeft() {
            if (!this.leaderLeft) {
                return;
            }
            this.compareService.remove(this.leaderLeft);
            this.leaderLeft = null;
        }

        clearRight() {
            if (!this.leaderRight) {
                return;
            }
            this.compareService.remove(this.leaderRight);
            this.leaderRight = null;
        }

        callAction(trader) {
            const {CopyAction} = this.types;
            if (trader.isFollowed) {
                return this.utils.navigate('root.app.socialFunds', {id: trader.id, action: CopyAction.AddFunds})
            }

            this.actionService.stateCheck({trader, action: CopyAction.StartCopy})
        }
    }
});
